import { useRef, useEffect, type CSSProperties } from "react";

interface TableSearchProps {
  query: string;
  onChange: (query: string) => void;
  plural: string;
}

export function TableSearch({ query, onChange, plural }: TableSearchProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (
        e.key === "/" &&
        !e.ctrlKey &&
        !e.metaKey &&
        !(e.target instanceof HTMLInputElement) &&
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLSelectElement)
      ) {
        e.preventDefault();
        inputRef.current?.focus();
      }
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  const wrapper: CSSProperties = {
    position: "relative",
    maxWidth: 360,
    marginBottom: 8,
  };

  const icon: CSSProperties = {
    position: "absolute",
    left: 10,
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 14,
    color: "var(--color-text-tertiary)",
    pointerEvents: "none",
  };

  const input: CSSProperties = {
    width: "100%",
    fontSize: 13,
    padding: "7px 10px 7px 30px",
    border: "0.5px solid var(--color-border-secondary)",
    borderRadius: "var(--border-radius-md)",
    background: "var(--color-background-primary)",
    color: "var(--color-text-primary)",
    fontFamily: "var(--font-sans)",
    outline: "none",
    boxSizing: "border-box",
  };

  return (
    <div style={wrapper}>
      <i className="ti ti-search" style={icon} aria-hidden="true" />
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        placeholder={`Search ${plural}...`}
        style={input}
      />
    </div>
  );
}
